'use strict';

var React = require('react');

var SvgWifiMajor = function SvgWifiMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.218a.75.75 0 0 0 1.06 1.06 9.5 9.5 0 0 1 13.435 0 .75.75 0 1 0 1.061-1.06c-4.296-4.296-11.26-4.296-15.556 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.725 10.753a.75.75 0 0 1 0-1.06 7.5 7.5 0 0 1 10.606 0 .75.75 0 1 1-1.06 1.06 6 6 0 0 0-8.486 0 .75.75 0 0 1-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.846 11.814a.75.75 0 0 0 1.06 1.06 3 3 0 0 1 4.243 0 .75.75 0 1 0 1.06-1.06 4.5 4.5 0 0 0-6.363 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.967 13.936a1.5 1.5 0 1 0 2.122 2.121 1.5 1.5 0 0 0-2.122-2.121Z"
  }));
};
SvgWifiMajor.displayName = "WifiMajor";

exports.SvgWifiMajor = SvgWifiMajor;
